import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Class representing the Redirect Guard service
 */
@Injectable()
export class RedirectGuard {
  /**
   * Redirect Guard
   * @param router - Angular router
   */
  constructor(private readonly router: Router) {}

  /**
   * Redirect the user
   * @param route - Activate route snapshot
   * @param state - Router state snapshot
   * @returns If route is allowed
   */
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    if (window.location.origin === environment.cdn) {
      this.router.navigateByUrl('/account/dashboard');
      return false;
    }

    window.location.href = route.data['externalUrl'];
    return true;
  }
}
